export default {
	idItemBuscarFornecedores: null,
}
